import React from 'react';
import { create } from 'zustand';
import { Dialog } from './Dialog';
import { Button } from './Button';

// Confirmación propia en lugar de window.confirm(): accesible (role=alertdialog, foco atrapado,
// Escape = cancelar) y con el estilo de la app. La pinta <ConfirmHost /> (montado una vez en App).
//
//   const confirmar = useConfirmar();
//   if (!(await confirmar({ titulo: '¿Eliminar la meta?', mensaje: '…', confirmar: 'Eliminar', peligro: true }))) return;
//
// Cancelar, Escape, ✕ o clic fuera resuelven false; solo el botón de confirmar resuelve true.

const useConfirmStore = create(() => ({ pedido: null }));
let resolverActual = null;

function resolver(ok) {
  const r = resolverActual;
  resolverActual = null;
  useConfirmStore.setState({ pedido: null });
  if (r) r(ok);
}

/** Abre la confirmación y devuelve Promise<boolean>. Acepta un texto o { titulo, mensaje, confirmar, cancelar, peligro }. */
export function confirmar(opciones) {
  const pedido = typeof opciones === 'string' ? { mensaje: opciones } : { ...opciones };
  // Una confirmación nueva cancela la anterior que siguiera abierta: nunca queda una promesa colgada.
  if (resolverActual) resolver(false);
  return new Promise((res) => {
    resolverActual = res;
    useConfirmStore.setState({ pedido });
  });
}

export function useConfirmar() {
  return confirmar;
}

export function ConfirmHost() {
  const pedido = useConfirmStore(s => s.pedido);
  if (!pedido) return null;
  return (
    <Dialog abierto alerta ancho="max-w-md" onCerrar={() => resolver(false)}
      titulo={pedido.titulo || '¿Confirmas esta acción?'}
      descripcion={pedido.mensaje}
      pie={(
        <>
          <Button variant="secondary" onClick={() => resolver(false)} data-autofocus={pedido.peligro ? true : undefined}>
            {pedido.cancelar || 'Cancelar'}
          </Button>
          <Button variant={pedido.peligro ? 'danger' : 'primary'} onClick={() => resolver(true)} data-autofocus={pedido.peligro ? undefined : true}>
            {pedido.confirmar || 'Confirmar'}
          </Button>
        </>
      )}
    />
  );
}
